// Centralized development flags for cloud-for-orgs feature testing. These can be
// enabled in two ways:
//   1. During development (pnpm dev): import.meta.env.DEV is true
//   2. In builds: Set VITE_ENABLE_DEV_FLAGS=true in .env or environment

const isDev = import.meta.env.DEV
const forceDevFlags = import.meta.env.VITE_ENABLE_DEV_FLAGS === "true"

const devFlagsEnabled = isDev || forceDevFlags

export const DEV_FLAGS = {
  // Forces the app to behave as if it's on an org subdomain even when running on
  // localhost or the default cloud instance. Flip to true to test the org switcher
  // without needing a real org subdomain.
  FORCE_ORG_MODE: devFlagsEnabled && false,

  // Uses mock organization data instead of fetching from the API. Flip to true to
  // test the org switcher UI without a backend or real org memberships.
  USE_MOCK_ORGANIZATIONS: devFlagsEnabled && false,

  // Manually override the organization host when running on localhost to test
  // auth methods/SSO configurations for a specific organization without Firebase domain validation issues.
  // Set VITE_TEST_ORG_HOST in your .env file to e.g. "flipkart" or "flipkart.localhost".
  TEST_ORG_HOST: (import.meta.env.VITE_TEST_ORG_HOST || undefined) as string | undefined,
} as const

export type DevFlags = typeof DEV_FLAGS
